import { forRails } from 'components/for-rails'
import { WithWorkEmailError } from '../src/components/with-work-email-error'
import { TemplatePage } from 'components/template-page'
import { registerComponents } from '../src/utils/react/registry'

registerComponents({
  WithWorkEmailError: forRails(WithWorkEmailError),
  TemplatePage: forRails(TemplatePage),
})
